import * as Sentry from '@sentry/react';
import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';
import {FlexContainer} from 'app/styles/content';

const Information = styled.div`
  line-height: ${SIZES['20']};
  text-align: center;
  padding: 0 ${SIZES['16']} ${SIZES['16']} ${SIZES['16']};
  ${props => (props.margin ? `margin-top: ${SIZES['16']}` : '')}
`;

const Container = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  padding: ${SIZES['16']} ${SIZES['16']} 0;
  min-height: 10.25rem;

  a {
    text-decoration: none;
  }
`;

const RequestErrorHandler = (error, match) => {
  let finalError = {
    message: 'Es ist ein unerwarteter Fehler aufgetreten.',
  };
  if (error.response?.data?.error.code === 403) {
    finalError = {
      ...error.response.data.error,
    };
  }

  if (!error.response?.data?.error) {
    // Report to sentry if error does not match expected scheme
    const scope = Sentry.getCurrentScope();
    scope.setContext('ticker-subscribe', {match_slug: match});
    Sentry.captureException(error);
  }

  return finalError;
};

export {RequestErrorHandler, Information, Container};
